import { FilterType, IHeadCell, OperatorFilterEnum, SelectFilterModelSimple } from '../../../common/types';
import { formatDateTimeToShowUserFromSaleOrderApiValue, formatDateToShowUser } from '../../../common/helpers';
import { IFlightAndFlightAncillaryETicketSummary } from '../../types';
import { FlightAncillaryTypeEnum } from '../../../salesOrder/types';

export enum FlightTicketTypeEnum {
	Emision = 'emision',
	Reemision = 're_emision',
}

export interface IETicketTypeOption {
	id: string;
	name: string;
}

export const eticketTypeOptions: IETicketTypeOption[] = [
	// Ticket types
	{
		id: FlightTicketTypeEnum.Emision,
		name: 'Emisión',
	},
	{
		id: FlightTicketTypeEnum.Reemision,
		name: 'Reemisión',
	},

	// Ancillary types
	{
		id: FlightAncillaryTypeEnum.Seat,
		name: 'Asientos',
	},
	{
		id: FlightAncillaryTypeEnum.CabinBaggage,
		name: 'Equipaje en cabina',
	},
	{
		id: FlightAncillaryTypeEnum.CheckedBaggage,
		name: 'Equipaje en bodega',
	},
	{
		id: FlightAncillaryTypeEnum.Pet,
		name: 'Mascota',
	},
	{
		id: FlightAncillaryTypeEnum.InFlightEntertainment,
		name: 'Entretenimiento a bordo',
	},
	{
		id: FlightAncillaryTypeEnum.Meal,
		name: 'Comidas',
	},
	{
		id: FlightAncillaryTypeEnum.SpecialLuggage,
		name: 'Equipajes especiales',
	},
	{
		id: FlightAncillaryTypeEnum.AccompaniedMinor,
		name: 'Menor acompañado',
	},
];

export function getETicketTypeName(id: string): string {
	const option = eticketTypeOptions.find((option) => option.id === id);
	return option ? option.name : id;
}

export const flightAndAncillaryETicketSummaryListHeaderCells: IHeadCell[] = [
	{
		field: 'eTicket',
		sortable: true,
		headerName: 'Ticket',
	},
	{
		field: 'serviceCreatedAt',
		sortable: true,
		headerName: 'Fecha de creación',
	},
	{
		field: 'passengerName',
		sortable: true,
		headerName: 'Nombre del pasajero',
	},
	{
		field: 'birthdate',
		sortable: true,
		headerName: 'Fecha de nacimiento',
	},
	{
		field: 'serviceReference',
		sortable: true,
		headerName: 'PNR',
	},
	{
		field: 'saleOrderDealId',
		sortable: true,
		headerName: 'Caso de venta',
	},
	{
		field: 'saleOrderId',
		sortable: true,
		headerName: 'SO',
	},
	{
		field: 'serviceId',
		sortable: true,
		headerName: 'Item de la orden',
	},
	{
		field: 'issueRequestCaseId',
		sortable: true,
		headerName: 'Caso de solicitud',
	},
	{
		field: 'issueRequestCaseCreatedAt',
		sortable: true,
		headerName: 'Fecha de solicitud',
	},
	{
		field: 'providerFantasyName',
		sortable: true,
		headerName: 'Proveedor',
	},
	{
		field: 'serviceCost',
		sortable: true,
		headerName: 'Costo',
	},

	{
		field: 'paymentDateToProvider',
		sortable: true,
		headerName: 'Fecha de pago a proveedor',
	},
	{
		field: 'vcCode',
		sortable: true,
		headerName: 'Validating carrier',
	},
	{
		field: 'ticketType',
		sortable: true,
		headerName: 'Tipo',
	},
];

export const flightAndAncillaryETicketSummaryListFilters = [
	{ label: 'Fecha de creación', type: FilterType.DATE, key: 'serviceCreatedAt' },
	{ label: 'Fecha de solicitud', type: FilterType.DATE, key: 'issueRequestCaseCreatedAt' },
	{ label: 'Ticket', type: FilterType.STRING, key: 'eTicket', operator: OperatorFilterEnum.CONTAINS },
	{ label: 'PNR', type: FilterType.STRING, key: 'serviceReference', operator: OperatorFilterEnum.CONTAINS },
	{ label: 'Caso de venta', type: FilterType.NUMERIC, key: 'saleOrderDealId', operator: OperatorFilterEnum.EQUALS },
	{
		label: 'Caso de solicitud',
		type: FilterType.NUMERIC,
		key: 'issueRequestCaseId',
		operator: OperatorFilterEnum.EQUALS,
	},
	{ label: 'Proveedor', type: FilterType.STRING, key: 'providerFantasyName', operator: OperatorFilterEnum.CONTAINS },
	{ label: 'Fecha de pago a proveedor', type: FilterType.DATE, key: 'paymentDateToProvider' },
	{ label: 'Fecha de pago a proveedor desde', type: FilterType.DATE, key: 'paymentDateToProviderFrom' },
	{ label: 'Fecha de pago a proveedor hasta', type: FilterType.DATE, key: 'paymentDateToProviderTo' },
	{ label: 'Validating carrier', type: FilterType.STRING, key: 'vcCode', operator: OperatorFilterEnum.EQUALS },
	new SelectFilterModelSimple('Tipo', 'ticketType', eticketTypeOptions),
];

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const transformValue = (key: string, value: any, row: IFlightAndFlightAncillaryETicketSummary): any => {
	switch (key) {
		case 'serviceCreatedAt':
			return formatDateTimeToShowUserFromSaleOrderApiValue(row.serviceCreatedAt);
		case 'issueRequestCaseCreatedAt':
			return row.issueRequestCaseCreatedAt ? formatDateTimeToShowUserFromSaleOrderApiValue(row.serviceCreatedAt) : '-';
		case 'birthdate':
			return formatDateToShowUser(row.birthdate);
		case 'paymentDateToProvider':
			return row.paymentDateToProvider ? formatDateToShowUser(row.paymentDateToProvider) : '-';
		case 'ticketType':
			return getETicketTypeName(row.ticketType);
		case 'issueRequestCaseId':
			return row.issueRequestCaseId != null ? row.issueRequestCaseId : '-';
		case 'serviceCost':
			return row.serviceCost != null ? row.serviceCost : '-';
		case 'providerFantasyName':
			return row.providerFantasyName && row.providerBusinessName
				? row.providerFantasyName + ` (${row.providerBusinessName})`
				: '-';
		default:
			return value;
	}
};
